import React, { Component } from 'react';

import Aux from '../../hoc/ReactAux';
import LowerHeader from '../../components/Header/LowerHeader/LowerHeader';
import DealerTable from '../../components/Dealers/DealerTable';
import Toolbar from '../../components/Header/Toolbar/Toolbar';

class DealersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken: localStorage.getItem('authToken'),
    };
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-header">
            <Toolbar />
        </div>
        <div className="container-fluid text-center">
          <LowerHeader pageTitle="Dealer" />
          <DealerTable features={this.state.features} />
        </div>
      </React.Fragment>
    );
  }
}

export default DealersContainer;



// WEBPACK FOOTER //
// ./src/containers/Dealers/DealersContainer.js